import React from 'react';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import HouseholdSectionBillingLayout from './HouseholdSectionBillingLayout';

const HouseholdSectionBillingOverride = buildFacetDesignOverride();

function HouseholdSectionService({ collection }) {
  return (
    <MetaFormInline
      resource={collection?.resources()?.head()}
      layout={HouseholdSectionBillingLayout}
      noIndividualSubmitButtons
      padding={'none'}
      metaOverrideSet={HouseholdSectionBillingOverride}
    />
  );
}

HouseholdSectionService.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default HouseholdSectionService;
